module.exports = __webpack_public_path__ + "img/web-development.5eb54e09.svg";